import React from "react";
import Icon, { type IconProps } from "./Icon";
/** KeyRound — Lucide. https://lucide.dev/icons/key-round (MIT). Copied 2026-05-16.
 *  Phase 3d: AdminAudit auth.view-password rotation marker. */
export default function KeyRound(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
      <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
    </Icon>
  );
}
